function getState(managestate) {
    localStorage.setItem("manage",managestate)
   
    return {
        type: "MANAGE_STATE",
        managestate
    }
}

export const ManageAction = (managestate) => dispatch => {
   // let manage = managestate;
    dispatch(getState(managestate))
}


// WEBPACK FOOTER //
// ./src/actions/managesignin.jsx